// 组件对象，大写
import selectOfInvoiceModalTable from './selectOfInvoiceModalTable.vue'
export default selectOfInvoiceModalTable
